import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CuDueDateTypeService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/cu-due-date-types', params);
    }

    store(body: any) {
        return super.post('/cu-due-date-types', body);
    }

    edit(cuDueDateTypeId: number) {
        return super.get(`/cu-due-date-types/${cuDueDateTypeId}/edit`);
    }

    update(cuDueDateTypeId: number, body: any) {
        return super.put(`/cu-due-date-types/${cuDueDateTypeId}`, body);
    }

    destroy(cuDueDateTypeId: number) {
        return super.delete(`/cu-due-date-types/${cuDueDateTypeId}`);
    }

    select(params: any = {}) {
        return super.get('/cu-due-date-types/select', params);
    }
}
